import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { SharedServices } from '../../services/shared.services'
import { ActivatedRoute, Router } from '@angular/router'
import { RestServices } from '../../services/rest.services'
import { AuthService } from '../../services/auth.services'
import * as moment from 'moment'
import { undefinedIsTrue } from '../../../helper'

@Component({
    selector: 'ons-page[tabHome]',
    templateUrl: './top.component.html',
    styleUrls: [
        '../../stagingcss/main-body.component.css',
        '../../stagingcss/lui-select.component.css',
        './top.component.css'],
    encapsulation: ViewEncapsulation.None,
})
export class TopComponent implements OnInit {
    clientId
    clientInfo
    alignerId
    alignerInfo = { lastPassedAlignerCount: '', totalNumber: '' }
    loadChart = false
    textChangeAligner = 'N/A'
    changeAlignetNotToday = false
    nextTimeAligner = ''
    displayChart = true
    useTreatmentMenu = false

    constructor(private route: ActivatedRoute, private authData: AuthService, private router: Router, private restApi: RestServices, private _sharedService: SharedServices) {
        _sharedService.changeEmittedSource$.subscribe(
            success => {
                this.clientInfo = success[0]
                this.useTreatmentMenu = undefinedIsTrue(this.clientInfo.useTreatmentMenu)
                this.alignerId = this.clientInfo.activeAligner
                this.alignerInfo = success[1].find(aigner => aigner._id === this.alignerId)
                this.loadChart = true
                let array_test
                let numPassess
                let current_time = moment().startOf('day').valueOf()
                // startDate
                if (this.alignerId && parseInt(this.alignerInfo.lastPassedAlignerCount) > 0) {
                    array_test = this.alignerInfo['aligners'].find(aigner => aigner.startDate >= current_time)
                    numPassess = this.alignerInfo['aligners'].findIndex(aigner => aigner.startDate >= current_time)
                    if (array_test && (numPassess + 1) <= this.alignerInfo.lastPassedAlignerCount) {
                        this.diffTimeChangeAligner(moment(array_test.startDate))
                    }
                } else {
                    this.textChangeAligner = 'N/A'
                    this.changeAlignetNotToday = false
                }
            },
        )
        this._sharedService.changeEmitted$.subscribe(
            res => {
                this.displayChart = res[0] === 'changePageMobileApp' && res[1] === 1
            })
    }

    ngOnInit() {
        
    }

    changePageHome(index, index2) {
        this._sharedService.emitChange(['changePageApp', index, index2])
    }

    onAction($event) {
        setTimeout(() => {
            $event.done()
        }, 100)
    }

    diffTimeChangeAligner(timeChange) {
        let diffRes = moment().startOf('day').diff(timeChange, 'days')
        if (diffRes === 0) {
            this.textChangeAligner = 'Today'
        } else {
            this.textChangeAligner = diffRes * -1 + ''
            this.changeAlignetNotToday = true
            this.nextTimeAligner = moment(timeChange).format('DD MMM (ddd)')
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/client-app/top/top.component.ts